<!--     *********     FEATURES 3      *********      -->

<div class="features-3 pb-0">
  <div class="container">






    <div class="row">


      <!-- <div class="col-md-5 ml-auto mr-auto text-center justify-content-center align-items-center">
        <div class="row">
          <div class="container">
            <h3 class="title">More of Our Services and Integration Options...</h3>
          </div>
        </div>
        
      </div> -->

      <div class="col-md-12">

        

        <div class="row">




          <div class="col-md-4">

            <div class="info info-horizontal">
              <div class="icon icon-warning">
                <i class="nc-icon nc-www"></i>
              </div>
              <div class="description">



                <img class="mt-3 mb-5 img img-container" style="max-height: 75px; max-width: 250px;" alt="" src="./assets/img/brand/eMD_Cloud.png">


                <p>Improved Clinical Notes and Electronic  Medical Records (EMR) are now available on our cloud application.</p>

             
                <ul>
                  <li>Medical History</li>
                  <li>Main Complaint</li>
                  <li>Examination</li>
                  <li>Vital Signs</li>
                  <li>Investigations</li>
                  <li>Graphs</li>
                  <li>Assessment</li>
                  <li>Attachments</li>
                  <li>Plan</li>
                  <li>Treatment</li>
                  <li>Attachments</li>
                  <li>Electronic Patient Consent</li>
                  <li>Graphically Represented Clinical Results</li>
                  <li>Pathology Results</li>
                  <li>e-AI</li>
                </ul>
               
              </div>
            </div>
          </div>
          <div class="col-md-4">





            <div class="info info-horizontal">
              <div class="icon icon-warning">
                <i class="nc-icon nc-www"></i>
              </div>
              <div class="description">





                <img class="mt-1 mb-4" style="max-height: 75px;" alt="" src="./assets/img/brand/e-AI_logo.png">



                <p>This new AI-powered feature will assist in making precision diagnosis and treatment decisions.</p>


                <ul>
                  <li>Precision diagnosis and treatment</li>
                  <li>Instant diagnosis saves time</li>
                  <li>Improved treatment plans</li>
                  <li>Comprehensive Differential Diagnosis</li>
                  <li>Access to much more Clinical information</li>
                  <li>Letters</li>
                  <li>Drug Interaction</li>
                  <li>Contraindications</li>
                  <li>e-AI Assistant</li>

                  <li>Additional features launching soon...</li>
                </ul>
              </div>
            </div>





          </div>

          <div class="col-md-4">

            <div class="info info-horizontal">
              <div class="icon icon-warning">
                <i class="nc-icon nc-www"></i>
              </div>
              <div class="description">


                <img class="mt-1 mb-4" style="max-height: 50px;" alt="" src="./assets/img/brand/eScript.png">

                <p>e-Scripting will assist doctors in creating a script electronically while creating a claim and
                  submitting it in real-time to Dischem.</p>
                <ul>
                  <li>Real-time prescriptions to the Pharmacy</li>
                  <li>Saves time by skipping the long queues</li>
                  <li>Convenient as prescriptions can be delivered</li>

                </ul>
                <h5 class="info-title mb-4 mt-4"> <strong> in collaboration with </strong> </h5>
                <a href="https://www.dischem.co.za/" target="_blank">
                  <img class="img img-responsive" src="./assets/img/brand/Dis-Chem.png" style="width: 50%;">
                </a>

              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>


<div class="features-66 pb-0">
  <div class="container">
    <div class="row ml-auto mr-auto">
      <div class="col-lg-12 mt-lg-n2 ml-auto mr-auto ">
        <img class=" img-fluid img-responsive rounded" alt="" src="./assets/img/website_2/image_3.png">
      </div>
    </div>
  </div>
</div>